import type { FeatureStatus } from "@/types/content";

export interface DocSurface {
  id: string;
  title: string;
  status: FeatureStatus;
  body: string;
  link?: { label: string; to: string };
}

/**
 * Honest inventory of what a developer can actually reach today — SDK, CLI and
 * the protocol surfaces covered on /agent-user-interface. No code samples are
 * shown for capabilities that do not exist yet; see docs/CONTENT_GUIDE.md.
 */
export const docSurfaces: DocSurface[] = [
  {
    id: "sdk",
    title: "SDK",
    status: "in-development",
    body: "A typed TypeScript client for calling the Devory Gateway. Today it is a thin transport layer that does not yet know about projects, graphs or Marketplace listings by name. A component-authoring workflow is planned, not available yet.",
  },
  {
    id: "cli",
    title: "CLI",
    status: "in-development",
    body: "A terminal interface into Devory. Today it parses arguments, prints version information and runs a local health check. Commands for authentication, projects, graphs, qualification and Marketplace publishing are designed but not implemented, and fail loudly rather than pretend to succeed.",
  },
  {
    id: "protocol",
    title: "AUI & MCP protocol reference",
    status: "in-development",
    body: "The capability, resource-scope, operation, audit-envelope and external-agent-principal contracts an AI agent is built against, and how the MCP transport carries them.",
    link: { label: "Read the protocol overview", to: "/agent-user-interface" },
  },
  {
    id: "components",
    title: "Component model",
    status: "pilot",
    body: "How a component is structured (type, configuration, inputs, outputs, version, state and connections), and the qualification pipeline it must pass before it can be reused.",
    link: { label: "Read the component model", to: "/components" },
  },
];
